import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, tokens } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { Outlet, useNavigation } from 'react-router';
import { Sidebar } from '#src/app/shell/Sidebar.js';
import { TopBar } from '#src/app/shell/TopBar.js';
import { LoadingState } from '#src/shared/ui/StateView.js';
import { MEDIA_COMPACT, useMediaQuery } from '#src/shared/ui/useMediaQuery.js';
const useStyles = makeStyles({
    root: {
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        // Tela levemente tingida pela cor da marca, como no Teams.
        backgroundImage: `linear-gradient(180deg, ${tokens.colorBrandBackground2} -60%, ${tokens.colorNeutralBackground2} 45%)`,
        backgroundColor: tokens.colorNeutralBackground2,
        color: tokens.colorNeutralForeground1,
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexBasis: 0,
        minWidth: 0,
    },
    content: { flexGrow: 1, minHeight: 0, overflowY: 'auto' },
});
const COLLAPSED_KEY = 'teams-kit.navigation.collapsed';
/** A barra recolhida é conveniência da pessoa: sem armazenamento, volta aberta. */
function readCollapsed() {
    try {
        return localStorage.getItem(COLLAPSED_KEY) === '1';
    }
    catch {
        return false;
    }
}
function saveCollapsed(collapsed) {
    try {
        localStorage.setItem(COLLAPSED_KEY, collapsed ? '1' : '0');
    }
    catch {
        // Sem armazenamento, vale até recarregar a página.
    }
}
export function AppShell() {
    const styles = useStyles();
    const compact = useMediaQuery(MEDIA_COMPACT);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(readCollapsed);
    const loadingPage = useNavigation().state === 'loading';
    // Ao alargar a tela, a gaveta dá lugar à barra fixa.
    useEffect(() => {
        if (!compact) {
            setDrawerOpen(false);
        }
    }, [compact]);
    return (_jsxs("div", { className: styles.root, children: [_jsx(Sidebar, { overlay: compact, open: drawerOpen, onOpenChange: setDrawerOpen, collapsed: collapsed, onCollapsedChange: (value) => {
                    saveCollapsed(value);
                    setCollapsed(value);
                } }), _jsxs("div", { className: styles.main, children: [_jsx(TopBar, { showMenu: compact, onOpenMenu: () => setDrawerOpen(true) }), _jsx("main", { className: styles.content, children: loadingPage ? _jsx(LoadingState, {}) : _jsx(Outlet, {}) })] })] }));
}
//# sourceMappingURL=AppShell.js.map